import React from 'react';
import './ForestClearance.css';
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import forest_dummy_1 from '../../assets/images/forest-clearance-1.jpg';
import Footer from '../../components/footer/Footer';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_forest_banner from '../../assets/images/img_peso1_banner.png';
import { FaTree, FaFileAlt, FaHandshake, FaCogs, FaComments, FaPaperPlane, FaCertificate } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function ForestClearance() {
  const forestBenefits = [
    {
      icon: <FaTree />,
      title: 'Environmental Compliance',
      text: 'Ensure adherence to environmental laws and regulations.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Legal Assurance',
      text: 'Minimize legal risks with proper forest clearance.',
    },
    {
      icon: <FaHandshake />,
      title: 'Stakeholder Trust',
      text: 'Build trust with stakeholders by demonstrating compliance.',
    },
    {
      icon: <FaCogs />,
      title: 'Project Feasibility',
      text: 'Avoid delays in project implementation.',
    },
  ];

  const steps = [
    {
      icon: <FaComments />,
      title: 'Initial Consultation',
      description: 'Discuss your project and forest clearance requirements.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Documentation Preparation',
      description: 'Compile all necessary documents for submission.',
    },
    {
      icon: <FaTree />,
      title: 'Impact Assessment',
      description: 'Conduct an environmental impact assessment.',
    },
    {
      icon: <FaPaperPlane />,
      title: 'Application Submission',
      description: 'Submit the application and handle follow-ups.',
    },
    {
      icon: <FaCertificate />,
      title: 'Approval Issuance',
      description: 'Obtain forest clearance approval to proceed.',
    },
  ];

  const acts = [
    "Forest Conservation Act, 1980",
    "Environmental Protection Act, 1986",
    "Wildlife Protection Act, 1972",
    "Indian Forest Act, 1927"
  ];

  const explanation = "These regulations ensure sustainable development while protecting forest resources and biodiversity.";
  
  const checklistItems = [
    { name: 'Land Ownership Documents', description: 'Provide proof of ownership for the project site.' },
    { name: 'Environmental Impact Assessment', description: 'Submit a detailed EIA report.' },
    { name: 'Project Proposal', description: 'Provide a comprehensive project proposal document.' },
    { name: 'Affidavit', description: 'Submit an affidavit of compliance with forest conservation rules.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Forest Clearance Services"
        subheading="Simplify the process of obtaining forest clearance for your projects."
        ctaPrimary={{ text: "Request Consultation", link: "/contact-us" }}
        ctaSecondary={{ text: "Learn More", link: "/forest-clearance" }}
        backgroundImage={forest_dummy_1}
      />

      <ServicesOverviewSection
        title="What is Forest Clearance?"
        description="Forest clearance is mandatory for projects that require the use of forest land. We assist you in navigating the application and approval process seamlessly."
        image={img_forest_banner}
        altText="Forest Clearance Process"
      />

      <ServicesBenefitsSection
        title="Why You Need Forest Clearance"
        description="Learn how forest clearance benefits your project and ensures compliance."
        benefits={forestBenefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Environmental and Forest Conservation Regulations"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Simple Forest Clearance Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="Forest Clearance Onboarding Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
